// 개발/운영 공통 스위치 — 이 값 하나만 바꾸면 된다.
// true : 개발 접근 제어 활성화 + TEST API 사용
// false: 개발 접근 제어 비활성화 + OFFICIAL API 사용
//
// App.js 가 아니라 별도 모듈에 두는 이유:
// App.js -> ... -> callApi.js -> App.js 로 import 가 한 바퀴 돌면
// callApi 가 App.js 평가 도중에 로드되면서 isDevMode 를 초기화 전에 읽어
// "Cannot access 'isDevMode' before initialization" 이 발생한다.
export const isDevMode = false;
